let navigateGlobalFn = null;

export const registerGlobalNavigate = (fn) => {
  navigateGlobalFn = fn;
};

export const navigateGlobal = (to, options = {}) => {
  if (navigateGlobalFn) {
    navigateGlobalFn(to, options);
  } else {
    window.location.href = to;
  }
};
